import { render } from "./UnableToContact.vue?vue&type=template&id=bc869d88&scoped=true&lang=pug"
import script from "./UnableToContact.vue?vue&type=script&lang=js"
export * from "./UnableToContact.vue?vue&type=script&lang=js"

import "./UnableToContact.vue?vue&type=style&index=0&id=bc869d88&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc869d88"]])

export default __exports__